import { STATUS } from "../config/taskData";
import { Clock3 } from "lucide-react";
import { getAvatarColor, getDeadlineCountdown } from "../utils/tasks";

function resolveDisplayTime(deadlineAt, time) {
  if (time) return time;

  const raw = typeof deadlineAt === "string" ? deadlineAt.trim() : "";
  const matchedTime = raw.match(/T(\d{2}:\d{2})/)?.[1];
  if (matchedTime) return matchedTime;

  if (!raw) return "Bez godziny";

  const direct = new Date(raw);
  if (Number.isNaN(direct.getTime())) return "Bez godziny";

  return direct.toLocaleTimeString("pl-PL", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function TaskCard({ task, onOpen, onEditContractor, hideContractor }) {
  const st = STATUS[task.status];
  const isUnassigned = !task.contact || task.contact.id === -1;
  const isSelf = task.contact && task.contact.id === 0;
  const avatarColor = task.contact
    ? getAvatarColor(task.contact.id)
    : "var(--color-text-disabled)";
  const timeLabel = resolveDisplayTime(task.deadlineAt, task.time);
  const countdownLabel = getDeadlineCountdown(task.deadlineAt || task.date, task.time);
  const whoLabel = isUnassigned
    ? "Nieprzypisane"
    : isSelf
    ? "Ja (Koordynator)"
    : task.contact.name;
  const taskDescription = task.desc || task.name || "Zadanie";

  return (
    <div
      onClick={onOpen}
      style={{
        background: "var(--color-bg-card)",
        border: "1px solid var(--color-border)",
        borderRadius: "var(--radius-md)",
        padding: "10px 12px",
        cursor: "pointer",
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) minmax(110px, 130px)",
        gap: 12,
        alignItems: "stretch",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 10,
          minWidth: 0,
        }}
      >
        <div
          style={{
            fontSize: "var(--text-xs)",
            color: "var(--color-primary)",
            fontWeight: "var(--font-medium)",
            fontVariantNumeric: "tabular-nums",
            lineHeight: 1.35,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <Clock3 size={14} strokeWidth={2} />
          <div style={{ whiteSpace: "nowrap" }}>{timeLabel}</div>
        </div>
        <span
          style={{
            minWidth: 0,
            fontFamily: "Roboto, sans-serif",
            fontSize: "14px",
            color: "var(--color-text-primary)",
            fontWeight: 700,
            fontStyle: "normal",
            lineHeight: "140%",
            letterSpacing: "0",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={taskDescription}
        >
          {taskDescription}
        </span>
        {!hideContractor && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                background: avatarColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "var(--color-bg-card)",
                fontSize: "var(--text-xs)",
                fontWeight: "var(--font-semibold)",
                flexShrink: 0,
              }}
            >
              {isUnassigned ? "?" : whoLabel[0]}
            </div>
            <span
              style={{
                fontFamily: "Roboto, sans-serif",
                fontSize: "10px",
                color: isUnassigned ? "var(--color-warning)" : "var(--color-text-primary)",
                fontWeight: 400,
                fontStyle: "normal",
                lineHeight: "140%",
                letterSpacing: "0",
                cursor: task.contact ? "pointer" : "default",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              onClick={(e) => {
                if (!task.contact || !onEditContractor) return;
                e.stopPropagation();
                onEditContractor(task);
              }}
              title={task.contact ? "Kliknij, aby edytować wykonawcę" : undefined}
            >
              {whoLabel}
            </span>
          </div>
        )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            minWidth: 0,
            textAlign: "right",
            alignItems: "flex-end",
            gap: 10,
          }}
        >
          <div
            style={{
              fontFamily: "Roboto, sans-serif",
              fontSize: "12px",
              color: "var(--color-text-muted)",
              fontWeight: 400,
              fontStyle: "normal",
              lineHeight: "140%",
              letterSpacing: "0",
              textAlign: "right",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {countdownLabel}
          </div>
          <span
            style={{
              background: "var(--color-bg-card)",
              color: st?.color || "var(--color-text-muted)",
              border: `1px solid ${st?.border || "var(--color-border)"}`,
              borderRadius: "var(--radius-full)",
              padding: "2px 8px",
              fontFamily: "Roboto, sans-serif",
              fontSize: "12px",
              fontWeight: 400,
              fontStyle: "normal",
              lineHeight: "140%",
              letterSpacing: "0",
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            {st?.label || "Status"}
          </span>
      </div>
    </div>
  );
}
